<app-header></app-header>

<!-- ========== MAIN CONTENT ========== -->
<div id="feedback_screen" role="main" class="main">
  <!-- Content -->
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col">
        <div class="feedback_wrapper">
          <h1 class="display-6 fw-bold mb-3">The call is ended</h1>
          <ng-container [ngTemplateOutlet]="displayTemplate"></ng-container>

          <!-- <div class="powered_by text-center mt-6">
            <p>
              Powered by
              <img
                class="img-fluid w-10 ms-2"
                src="assets/images/powered_by.svg"
                alt="Powered by logo"
              />
            </p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- END Content -->
</div>

<ng-template #custfeedback>
  <!-- Star Feedback -->
  <div class="feedback text-center">
    <h4 class="fw-normal">How was audio/video quality of the call?</h4>
    <form
      [formGroup]="feedbackform"
      (ngSubmit)="onFeedbackSubmit(feedbackform)"
    >
      <ngb-rating formControlName="rating" [max]="5"></ngb-rating>
      <div class="rating-info w-70">
        <div class="d-flex align-items-center justify-content-between">
          <span>Bad</span>
          <span>Very Good</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <textarea
            name="review"
            cols="50"
            formControlName="review"
            rows="3"
            [placeholder]="placeholder"
          ></textarea>
        </div>
      </div>
      <button class="btn btn-primary btn-block" type="submit">Rate Now</button>
    </form>
  </div>

  <div class="later_btn">
    <button class="btn btn-link" (click)="goToLogin()">Maybe later</button>
  </div>
  <!-- END Star Feedback -->
</ng-template>

<ng-template #agentfeedback>
  <!-- Numeric Feedback -->
  <div class="experience_wrapper text-center">
    <div class="feedback text-center numeric">
      <h4 class="fw-normal">Rate your experience</h4>
      <form
        [formGroup]="feedbackform"
        (ngSubmit)="onFeedbackSubmit(feedbackform)"
      >
        <ngb-rating formControlName="rating" [max]="5"></ngb-rating>
        <button class="btn btn-primary btn-block" type="submit">Submit</button>
      </form>
    </div>

    <!-- <div class="later_btn">
      <button class="btn btn-link text-primary">
        Check your client emotional analysis here
      </button>
    </div> -->
  </div>
  <!-- END Numeric Feedback -->
</ng-template>

<ng-template #tankyou>
  <h3>Thank you for feedback!</h3>
</ng-template>
